import { render, staticRenderFns } from "./SellerConfig.vue?vue&type=template&id=d70ed55a&scoped=true&"
import script from "./SellerConfig.vue?vue&type=script&lang=js&"
export * from "./SellerConfig.vue?vue&type=script&lang=js&"
import style0 from "./SellerConfig.vue?vue&type=style&index=0&id=d70ed55a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70ed55a",
  null
  
)

export default component.exports